<template>
    <HarvestPlanManagement>
    </HarvestPlanManagement>
</template>

<script>
import HarvestPlanManagement from '@/components/harvestPlan/HarvestPlanManagement.vue'

export default {
    components: {
        HarvestPlanManagement
    },
    data(){
        return {

        };
    },
    computed: {
       
    },
    methods: {

    },
    created(){
        
    }
}
</script>